<script lang="ts" setup>
import type { IPlaylist } from "@/types";
import { PlaylistsModalCreate } from "#components";
import { PLAYLIST_TYPE } from "@/constants";

const props = defineProps<{
  playlist?: IPlaylist | null;
  editPlaylist: (name?: string) => void;
}>();

const modal = useModal();

const { t } = useI18n();

function onClick() {
  if (!props.playlist) {
    console.warn("[Playlist Edit] Playlist is missing", props.playlist);
    return;
  }

  modal.open(PlaylistsModalCreate, {
    showInstructions: false,
    playlist: props.playlist,
    onClose: () => modal.close(),
    "onPlaylist-updated": (name?: string) => props.editPlaylist(name),
  });
}
</script>

<template>
  <UListItem
    icon="edit"
    :text="t('labels.edit')"
    :disabled="playlist?.type === PLAYLIST_TYPE.SYSTEM || !playlist?.permissions?.canEdit"
    @click="onClick"
  />
</template>
